module.exports = __webpack_public_path__ + "static/media/monash.42b801a5.jpg";